import LoadingIcon from "../../assets/imgs/logo.png";
import Flex from "../flex/Flex";
export default function Loader() {
  return (
    <Flex customClass={"texture center"}>
      <img src={LoadingIcon} />
    </Flex>
  );
}
